.container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.filesGroup {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  height: 35px;
  align-items: center;
  padding: 0 10px;
  border-radius: 2px;
  margin: 0 5px 5px 0;
  background: var(--x-color-background);

  /* stylelint-disable-next-line selector-class-pattern -- Ant Design global class preserved from emotion source */

  :global(.ant-checkbox-wrapper) {
    margin-right: 5px;
  }
}
